<template>
  <VSuccessView
    >Meeting Booked
    <template #detail>{{ company.name }} might provide further details once they receive the invite, so be on the lookout!</template>
    <template #button>
      <VButton
        v-analytics="'bamSuccessViewExploreCompanyClicked'"
        variant="copper-outline"
        component="button"
        data-testid="success-view-explore-btn"
        @click="goToCompany"
        >Explore {{ company.name }}</VButton
      >
    </template>
  </VSuccessView>
</template>

<script lang="ts" setup>
import type { PropType } from 'vue'
import { CheckCircleIcon } from '@heroicons/vue/24/solid'
import type { Company } from '@/entities/company'

const router = useRouter()

const props = defineProps({
  company: {
    type: Object as PropType<Company>,
    required: true,
  },
})

async function goToCompany() {
  await navigateTo({ name: 'companies-id', params: { id: props.company.id } })
}
</script>
